module.exports = __webpack_public_path__ + "img/logo.cac73556.png";